<div class="side_tabs">
  <div class="side_tabs-title">Settings</div>

  <ul>
    <li>
      <a [routerLink]="['/dashboard/settings/edit/']" href="javascript:void(0);"
        >Edit Profile</a
      >
    </li>
    <li>
      <a class="hidden" [routerLink]="['/dashboard/settings/edit/']" href="javascript:void(0);"
        >Manage Notifications</a
      >
    </li>
    <li>
      <a
        [routerLink]="['/dashboard/settings/email/']"
        href="javascript:void(0);"
        >Change Email Address</a
      >
    </li>
    <li>
      <a
        [routerLink]="['/dashboard/settings/password/']"
        href="javascript:void(0);"
        >Change Passwords</a
      >
    </li>
    <li>
      <a
        [routerLink]="['/dashboard/settings/picture/']"
        href="javascript:void(0);"
        >Change Profile Picture</a
      >
    </li>
    <li>
      <a
        [routerLink]="['/dashboard/settings/delete_account/']"
        href="javascript:void(0);"
        >Delete Account</a
      >
    </li>
  </ul>
</div>
